import React, { useEffect, useContext, useRef } from 'react';
import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import SideMenu from '../../Splitter/SideMenu/SideMenu';
import { signed_offer_circle } from '../../../utils/images';
import { ExpertContext } from '../../Contexts/contexts';
import ClientHistoryElement from './ClientHistoryElement/ClientHistoryElement';
import useAuth from '../../Contexts/useAuth';
import useCheckout from '../../Contexts/useCheckout';
import usePaymentPeriod from '../../Contexts/usePaymentPeriod';

function History() {
  const expertContext = useContext(ExpertContext);

  const { checkAuth, validateRoleRoute } = useAuth();
  const checkout = useCheckout();
  const checkPaymentPeriod = usePaymentPeriod();
  const ref = useRef(true);

  // Fonction qui permet d'afficher les clients
  function getAllClientHistory() {
    const clientHistoryItems = [];

    expertContext
      ?.getClientExpertRelationsByStatus([-1, 4, 5, 6, 7])
      .forEach((clientExpertRelation) => {
        clientHistoryItems.push(
          <ClientHistoryElement
            clientExpertRelation={clientExpertRelation}
            id={clientExpertRelation.id}
            key={clientExpertRelation.id}
          />
        );
      });

    return clientHistoryItems;
  }

  useEffect(() => {
    if (checkAuth()) {
      if (validateRoleRoute('expert')) {
        if (checkout('/client-history')) {
          if (checkPaymentPeriod('/client-history')) {
            const firstRendering = ref.current;

            if (firstRendering) {
              ref.current = false;
              expertContext?.refreshClientExpertRelations();
              expertContext?.refreshAppointments();
            }
          }
        }
      }
    }
  }, [
    checkAuth,
    validateRoleRoute,
    checkout,
    checkPaymentPeriod,
    expertContext,
  ]);

  return (
    <>
      <HeaderMinimal />
      <div className="ts-container">
        <SideMenu />
        <div className="ts-container-main">
          <div className="ts-details-container">
            <div className="ts-details">
              <div className="ts-title">Historique clients</div>
              <div className="ts-resume">
                Nous vous proposons de conserver un historique détaillé de vos
                contrats conclus avec CEC, ainsi qu'un répertoire des clients
                que vous avez engagés grâce à CEC, comme indiqué ci-dessous.
                <br />
                Nous vous remercions pour votre confiance !
              </div>
            </div>
            <div className="ts-number">
              <div className="ts-number-container">
                <div className="ts-number-title">Cumul clients apportés</div>
                <div className="ts-number-current">
                  {
                    expertContext?.getClientExpertRelationsByStatus([
                      2, 3, 4, 5, 7,
                    ]).length
                  }
                </div>
              </div>
              <img
                className="ts-icon"
                src={signed_offer_circle}
                alt="devis icone"
              ></img>
              <div className="green-rod"></div>
            </div>
          </div>
          {expertContext?.getClientExpertRelationsByStatus([2, 3, 4, 5, 7])
            .length > 0 && (
            <div className="rdv-container">
              <div className="rdv-elements-container">
                {getAllClientHistory()}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default History;
